import React from "react";

const Calendar = () => {
  return (
    <svg
      aria-hidden="true"
      role="img"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.63672 3.59961H12.3633C12.8831 3.59961 13.4003 4.08207 13.4004 4.7998V13.2002C13.4003 13.918 12.8831 14.4004 12.3633 14.4004H3.63672C3.11693 14.4004 2.5997 13.9179 2.59961 13.2002V4.7998C2.5997 4.08208 3.11693 3.59961 3.63672 3.59961Z"
        stroke="#666666"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 6L13 6"
        stroke="#666666"
        strokeWidth="1.2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M5 3.75V1.75"
        stroke="#666666"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 3.75V1.75"
        stroke="#666666"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 8.25V10.3269L9.17308 11.5"
        stroke="#666666"
        strokeWidth="1.15"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Calendar;
